
import taskActions from '../../../actions/taskActions';
import taskTableColumns, {
  taskTableLeftFixedColumns,
  taskTableDataSortingByColumns,
  taskTableSummaries,
  TaskTableCellComponent,
  taskSelectionOperations,
} from './taskTableColumns';
import generateEntityTable from '../../../hocs/generateEntityTable';

const TasksTable = generateEntityTable({
  entityPluralString: 'tasks',
  entityActions: taskActions,
  editorRoutePath: '/task-edition',
  leftFixedColumns: taskTableLeftFixedColumns,
  dataSortingByColumns: taskTableDataSortingByColumns,
  selectionOperations: taskSelectionOperations,
  cellComponent: TaskTableCellComponent,
  columns: taskTableColumns,
  summaries: taskTableSummaries,
  enableSelection: true,
});

export default TasksTable;
